<template>
  <div
    class="page-container"
    v-if="
      !$route.path.includes('/products/advantages/') ||
      $route.path === '/products/advantages'
    "
  >
    <h1 class="page-title">{{ t("pages.products.advantages.title") }}</h1>
    <div class="partner-grid-container">
      <!-- 合作伙伴网格 - 静态展示 -->
      <div class="partner-grid">
        <div
          class="partner-card"
          v-for="(structure, index) in structuresList"
          :key="index"
          @click="handleStructureClick(structure.url)"
        >
          <div class="image-container">
            <img
              :src="structure.image"
              :alt="structure.title"
              v-if="structure.image"
            />
          </div>
          <div class="partner-info">
            <div class="partner-name">{{ structure.title }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <router-view></router-view>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useI18n } from "vue-i18n";
// 导入模块
import zhData from "../../../i18n/zh";
import enData from "../../../i18n/en";
import { useLangStore } from "../../../pinia/stores/lang";
import { useRouter } from "vue-router";
const { t } = useI18n();
const langStore = useLangStore();
const router = useRouter();
// 根据当前语言选择对应的翻译数据
const translationData = computed(() => {
  console.log("当前语言:", langStore.currentLang);
  return langStore.currentLang.startsWith("zh") ? zhData : enData;
});

// 获取荣誉资质数据
const structuresList = computed(() => {
  const data = translationData.value.pages.products.advantages.list;
  console.log("荣誉资质数据:", data);
  return data as {
    title: string;
    image: string;
  }[];
});
const handleStructureClick = (url: string) => {
  console.log("点击的结构:", url);
  // 根据不同的结构跳转到不同的路由
  switch (url) {
    case "technology":
      router.push("/products/advantages/technology");
      break;
    case "selfequipped":
      router.push("/products/advantages/selfequipped");
      break;
    case "qualitycontrol":
      router.push("/products/advantages/qualitycontrol");
      break;
    case "deliverycapability":
      router.push("/products/advantages/deliverycapability");
      break;
    default:
      console.warn("未知的跳转路径:", url);
  }
};
</script>

<style scoped lang="scss">
// 页面特定样式
.page-container {
  padding-bottom: 60px;
}

.page-subtitle {
  text-align: center;
  margin: -20px auto 30px;
  color: #666;
  font-size: 16px;
  max-width: 800px;
}

.structures-description {
  margin: 0 auto 40px;
  max-width: 1000px;
  text-align: justify;
  font-size: 16px;
  line-height: 1.6;
  color: #333;
  padding: 0 20px;
}

.structures-grid-container {
  padding: 0 20px;
  max-width: 1200px;
  margin: 0 auto;
}

.structures-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 25px;
}

.structure-card {
  background-color: #fff;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.15);
  }

  .image-container {
    height: 160px;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #f9f9f9;

    img {
      max-width: 100%;
      max-height: 100%;
      object-fit: contain;
    }
  }

  .structure-info {
    padding: 15px;

    .structure-title {
      font-size: 15px;
      font-weight: 500;
      color: #333;
      margin-bottom: 5px;
      text-align: center;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      height: 40px;
    }
  }
}

// 响应式优化
@media screen and (max-width: 768px) {
  .page-subtitle {
    font-size: 14px;
    margin: -15px auto 25px;
  }

  .structures-description {
    font-size: 14px;
    margin-bottom: 30px;
  }

  .structures-grid {
    grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
    gap: 15px;
  }

  .structure-card {
    .image-container {
      height: 120px;
    }

    .structure-info {
      padding: 10px;

      .structure-title {
        font-size: 13px;
      }
    }
  }
}
.page-container {
  padding-bottom: 60px;
}

.page-subtitle {
  text-align: center;
  margin: -20px auto 30px;
  color: #666;
  font-size: 16px;
  max-width: 800px;
}

.carousel-container {
  height: 70vh; // 设置轮播容器高度
  margin-top: 30px;
}

.layout-controls {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 30px;

  .switch-control {
    :deep(.el-switch__label) {
      color: #666;
    }
  }
}
.partner-grid-container .partner-grid {
  grid-template-columns: repeat(2, 1fr);
}
.partner-grid-container {
  height: calc(100vh - 200px);
}
</style>
